import {
  Text,
  Title,
  createStyles,
  Button,
  Group,
  Space,
  useMantineTheme,
  Box,
} from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";
import React, { useEffect, useState } from "react";
import { TAB_NAV_ENABLED, TAB_BAR_STICKY_HEIGHT } from "../utils/tabNavigation";
import { lightSurfaces } from "../theme";

// function PageListHeader( {title, handleAdd, handleRefresh, handleClose}){
function ActionButtons({ actionButtons }) {
  if (!actionButtons?.length) return null;
  return (
    <Group>
      {actionButtons.map(
        ({
          onClick,
          label,
          variant = "filled",
          loading = false,
          color,
          disabled = false,
          render,
        }) =>
          render ? (
            <React.Fragment key={label}>{render()}</React.Fragment>
          ) : (
            <Button
              size="xs"
              key={label}
              onClick={onClick}
              variant={variant}
              color={color}
              loading={loading}
              disabled={disabled}
            >
              {label}
            </Button>
          )
      )}
    </Group>
  );
}

function PageListHeader({ title, actionButtons, compact = false }) {
  const theme = useMantineTheme();
  const [isSticky, setIsSticky] = useState(false);
  const { width } = useViewportSize();
  const isMobile = width < 768;

  useEffect(() => {
    if (compact) return undefined;
    const handleScroll = () => {
      const isScrolling = window.scrollY > 0;
      setIsSticky(isScrolling);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [compact]);

  if (compact) {
    if (!actionButtons?.length) return null;
    return (
      <Group position="right" mb="sm">
        <ActionButtons actionButtons={actionButtons} />
      </Group>
    );
  }

  return (
    <div
      style={{
        position: !(isMobile && isSticky) ? "sticky" : "static",
        top: TAB_NAV_ENABLED ? TAB_BAR_STICKY_HEIGHT : 0,
        background:
          theme.colorScheme === "dark"
            ? theme.colors.dark[8]
            : lightSurfaces.canvas(theme),
        zIndex: TAB_NAV_ENABLED ? 5 : 10,
      }}
    >
      <Box pt={isSticky ? "lg" : 0}>
        <Group position="apart">
          <Title order={2}>{title}</Title>
          <span>
            <ActionButtons actionButtons={actionButtons} />
          </span>
        </Group>
      </Box>
      <Space h="lg" />
    </div>
  );
}

export default PageListHeader;
